import React from "react";
import "./Services.css";

function Services() {
  return (
    <section className="services" id="services">
      <div className="container">
        <h2>Nossos Serviços</h2>
        <div className="services-items">
          <div className="service-card">
            <h3>Transporte Executivo</h3>
            <p>
            Deslocar-se com estilo e tranquilidade é possível: escolha nosso Transporte Executivo. Conforto, confiança e atendimento premium estão a apenas um clique.
            Entre em contato e reserve já!
            </p>
          </div>
          <div className="service-card">
            <h3>Transporte de Eventos</h3>
            <p>
            Garanta a tranquilidade do seu evento do início ao fim! Nosso Transporte de Eventos oferece segurança, pontualidade e conforto para todos os participantes.
            Solicite agora seu orçamento e deixe o transporte por nossa conta!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
